import createTypes from 'redux-create-action-types';

export default createTypes('TRUST_UPDATE');
